export const theme = {
  breakpoints: ["768px", "1440px"],

  colors: {
    main: "#9072af",
    text: "#72499b",
    secondText: "#000000",
    motivationText: "#161616",
    white: "#fff",
    third: "#494949",
    activeBtn: "#765d90",
  },
  space: [142],
  fonts: {
    main: "Cormorant",
    title: "Cormorant SC",
    button: "Cormorant Infant",
    bona: "Bona Nova",
    digits: "Cardo",
    adv: "Pacifico",
    adv2: "Montserrat",
  },
  fontSizes: {
    xs: "12px",
  },
  fontWeights: {
    normal: 400,
    bold: 700,
  },
  borders: {
    none: "none",
    normal: "1px solid",
    tables: "0.5px solid #72499b",
  },
  radii: {
    none: "0",
    normal: "4px",
    round: "50%",
  },
  sizes: {
    mobile: "400px",
    tablet: "767.9px",
    desktop: "1440px",
    mobileModal: "380px",
    tabletModal: "718px",
    desktopModal: "1240px",
  },
  shadows: {
    activeBtn: "inset 0px 3.39488px 3.39488px rgba(0, 0, 0, 0.25)",
  },
};
